const toCelsius = {
  'Celsius': (c) => c,
  'Fahrenheit': (f) => (f - 32) * 5/9,
  'Kelvin': (k) => k - 273.15,
  'Rankine': (r) => (r - 491.67) * 5/9,
  'Réaumur': (re) => re * 5/4,
  'Delisle': (d) => 100 - d * 2/3,
  'Newton': (n) => n * 100/33,
  'Rømer': (ro) => (ro - 7.5) * 40/21
};

const fromCelsius = {
  'Celsius': (c) => c,
  'Fahrenheit': (c) => c * 9/5 + 32,
  'Kelvin': (c) => c + 273.15,
  'Rankine': (c) => (c + 273.15) * 9/5,
  'Réaumur': (c) => c * 4/5,
  'Delisle': (c) => (100 - c) * 3/2,
  'Newton': (c) => c * 33/100,
  'Rømer': (c) => c * 21/40 + 7.5
};

export const convertTemperature = (value, fromUnit, toUnit) => {
  const celsius = toCelsius[fromUnit](parseFloat(value));
  const result = fromCelsius[toUnit](celsius);
  return Number(result.toFixed(4));
};
